import type { RouteObject } from 'react-router-dom';

/**
 * Views 10 (boleta envelopes, D9) and 11 (folio usage, D10).
 *
 * Both routes are built and tested even though the menu destination
 * (`boletas.nav.ts`) stays `blockedByBackend`: `router.test.tsx` demands that
 * every `NAV_UNFILTERED` destination resolve to a real route, so the route
 * cannot be missing just because the sidebar link is filtered out.
 */
export const boletasRoutes: RouteObject[] = [
  {
    path: 'boletas',
    lazy: () =>
      import('@/routes/pages/BoletasPage').then((m) => ({
        Component: m.BoletasPage,
      })),
  },
  {
    path: 'consumo-folios',
    lazy: () =>
      import('@/routes/pages/ConsumoFoliosPage').then((m) => ({
        Component: m.ConsumoFoliosPage,
      })),
  },
];
